export default class Job {
  constructor(jobNumber = -1, jobEmployeeStatus = '', jobEmployeeNumber = 999) {
    this.jobNumber = jobNumber
    this.jobEmployeeStatus = jobEmployeeStatus
    this.jobEmployeeNumber = jobEmployeeNumber
  }

  mapFromApi(responseData) {
    this.jobNumber = responseData.job_no
    this.jobEmployeeStatus = responseData.status.trim()
    this.jobEmployeeNumber = responseData.emp_no
  }
}
